import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  institutions: [],
  loading: false,
  error: null
};

const institutionsSlice = createSlice({
  name: 'institutions',
  initialState,
  reducers: {
    setInstitutions: (state, action) => {
      state.institutions = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setInstitutions, setLoading, setError } = institutionsSlice.actions;
export default institutionsSlice.reducer;
